import React from "react";
import style from "./style";

const FakeMyProducts = () => {
  return (
    <div className="faker-my-products">
      <div className="skeleton title" />
      <div className="products">
        <div className="skeleton product width-50" />
        <div className="skeleton product width-50" />
        <div className="skeleton product width-100" />
        <div className="skeleton product width-50" />
        <div className="skeleton product width-50" />
        <div className="skeleton product width-50" />
        <div className="skeleton product width-50" />
      </div>
      <style jsx>{style}</style>
    </div>
  );
};

export default FakeMyProducts;
